// Single source of truth for site copy. Edit here without touching components.

export const CONTACT = {
  email: "calvin@chaptertwocreative.com",
  replyPromise: "I reply within 48 hours.",
};

export const NAV = [
  { label: "Services", href: "#services" },
  { label: "Work", href: "#work" },
  { label: "About", href: "#about" },
  { label: "FAQ", href: "#faq" },
];

export const HERO = {
  eyebrow: "Calvin To · Shopify expert and web developer · Las Vegas, NV",
  heading: "Your website and Shopify store, built and handled.",
  body: "I find the bottlenecks in how your business wins customers online, then fix them: the site, the store, the SEO, the follow-up. Shopify, Webflow and WordPress, for brands and local businesses. You work with me directly.",
  primaryCta: "Start a project",
};

// Facts only. Sources: Chapter-Two-Creative/Deliverables/job-hunt/ in Calvin's brain.
export const PROOF = [
  { big: "Since 2021", small: "building and running client websites" },
  { big: "3+ years", small: "managing one Shopify store, month to month" },
  { big: "+157%", small: "Bondeye store sessions, Q4 2024 vs Q4 2023" },
  { big: "IBM", small: "front-end engineering roots: React, accessibility" },
];

export const SERVICES = {
  heading: "What I do",
  items: [
    {
      title: "Website design and development",
      body: "Webflow, WordPress, Shopify or custom code. Built so you can edit it yourself.",
    },
    {
      title: "Shopify store management",
      body: "Themes, products, apps, speed, and Klaviyo email and SMS, every month.",
    },
    {
      title: "SEO and Google Business Profile",
      body: "Technical fixes, blog content and your Google profile, so customers find you.",
    },
    {
      title: "Funnel audits and fixes",
      body: "Where do visitors drop off before they buy or book? I find the bottleneck, then fix it.",
    },
  ],
  note: "Every job starts with an audit and a scope of work, so we agree on the problem before anything gets built.",
};

// `hidden: true` keeps a project off the page until its name, link and screenshot are in.
export const WORK = {
  heading: "Selected work",
  items: [
    {
      name: "Bondeye Jewelry",
      kind: "Shopify",
      years: "2023 to 2026",
      image: "/work/bondeye.webp",
      url: "https://bondeyejewelry.com",
      body: "Store redesign, then monthly management for over three years: theme work, products, Klaviyo email and SMS, and an SEO blog. Store sessions rose 157% from Q4 2023 to Q4 2024.",
    },
    {
      name: "Covey Law",
      kind: "Brand and website",
      years: "2024 to 2026",
      image: "/work/covey.webp",
      url: "https://covey.law",
      body: "Rebrand and website design for a Brooklyn law firm serving performing artists, nonprofits and businesses.",
    },
    {
      name: "Tai Shan Du Hu Association of America",
      kind: "Webflow, English and Chinese",
      years: "2026",
      image: "/work/dhaa.webp",
      url: "https://www.dhaanyc.org",
      body: "Website for a Brooklyn nonprofit preserving Chinese culture and supporting families: programs, scholarships, ways to get involved, and a full Chinese-language version.",
    },
    {
      name: "sendatape",
      kind: "Next.js app",
      years: "2026",
      image: "/work/sendatape.webp",
      url: "https://sendatape.com",
      body: "My own product: paste YouTube links, record a mixtape, and send it as a short link. Built with Next.js and React on Vercel.",
    },
    { hidden: true, name: "[Private lender]", kind: "Website and SEO", years: "2024", image: "", url: "",
      body: "Lead-generation site for a hard-money lender that routes each borrower to the right loan product." },
    { hidden: true, name: "[NorCal contractor]", kind: "Website", years: "2023", image: "", url: "",
      body: "Website for a grading, excavation and paving contractor: project portfolio and quote requests." },
    { hidden: true, name: "[Doodle breeder]", kind: "Website and management", years: "2022", image: "", url: "",
      body: "Website showing available pups, with application gating, a guardian program and ongoing management." },
  ],
};

export const ABOUT = {
  heading: "About",
  body: [
    "I'm Calvin To, a Shopify and web developer based in Las Vegas. I studied New Media Interactive Development at RIT, built interfaces as a front-end intern at IBM, and worked as a contract front-end engineer for startups.",
    "I started Chapter Two Creative in 2021 to build and run websites for owners who would rather not do it themselves, and I work with clients across the US.",
  ],
  tools: ["Shopify", "Webflow", "WordPress", "Klaviyo", "Next.js", "React", "TypeScript", "Google Business Profile"],
};

// Shown on the page and mirrored as FAQPage structured data in index.html. Keep the two in sync.
export const FAQ = {
  heading: "Frequently asked questions",
  items: [
    {
      q: "What platforms do you build on?",
      a: "Shopify for online stores, Webflow or WordPress for service businesses, and custom code (Next.js and React) when a template won't do the job.",
    },
    {
      q: "Do you only work with businesses in Las Vegas?",
      a: "No. I'm based in Las Vegas and work with clients across the US, from Brooklyn to California.",
    },
    {
      q: "How does a project start?",
      a: "Every job starts with an audit and a scope of work, so we agree on the problem I'm solving before anything gets built.",
    },
    {
      q: "Can I update the website myself afterward?",
      a: "Yes. Sites are built so you can edit your own content, and I can keep managing it month to month if you'd rather not.",
    },
    {
      q: "Do you offer monthly Shopify store management?",
      a: "Yes: theme updates, products and collections, apps, site speed, and Klaviyo email and SMS, handled every month.",
    },
    {
      q: "How fast do you reply?",
      a: "Within 48 hours. Use the form below or email calvin@chaptertwocreative.com.",
    },
  ],
};

export const CONTACT_FORM = {
  heading: "Tell me what you need",
  body: "A few lines is plenty. If it's easier, just email me.",
  services: ["Website", "Shopify store management", "SEO and Google profile", "Funnel audit or fix", "Not sure yet"],
  submit: "Send",
  sending: "Sending…",
  thanks: "Got it, thank you. I'll reply within 48 hours.",
};
